module.exports = __webpack_public_path__ + "img/toggle.a7f1d691.png";